export default __webpack_public_path__ + "static/media/hosp1.cc3cbee1.png";